export default __webpack_public_path__ + "static/media/Debris_Coverage.ecf3f8c2.svg";